import React, { FC } from 'react'
import './AdminHeader.scss'
import EmpNavMenu from '../NavMenu/EmpNavMenu'

interface propsType {
  publicAccess?: boolean
}
const EmpHeader: FC<propsType> = ({ publicAccess }) => {
  return (
    <div className='admin-header'>
      <EmpNavMenu publicAccess={publicAccess}></EmpNavMenu>
    </div>
  )
}

export default EmpHeader
